import { createApp } from 'vue';
import App from './App.vue';

import './assets/styles/main.css';

const app = createApp(App, { getApp: () => app });
app.mount('#app');
